<template>
    <div class="welcome">
        <h1>{{ $t('home.title') }}</h1>
        <p class="top_padded">{{ $t('home.sub_title') }}</p>
        <router-link to="register">
            <a class="primary_btn" href="">{{ $t('buttons.get_started_button') }}</a>
        </router-link>
    </div>
</template>
<script>
export default {
    name: 'AppHome'
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    h1{
    	text-transform: unset;
    }
</style>